import './App.css';
import Routers from './routing/Routes';

function App() {
  return <Routers />;
}


export default App;
